<template>
  <div>
    <el-card v-if="courseInfo" class="box-card">
      <template v-slot:header>
        <div class="header-content">
          <img :src="logoSrc" alt="Logo" class="logo" />
          <span class="title">{{ systemTitle }}</span>
        </div>
      </template>
      <div>
        <p><strong>ID编号：</strong>{{ courseInfo.id }}</p>
        <p><strong>类型：</strong>{{ courseInfo.type }}</p>
        <p><strong>课题：</strong>{{ courseInfo.topic }}</p>
        <p><strong>执教者：</strong>{{ courseInfo.teacher }}</p>
        <p><strong>指导老师：</strong>{{ courseInfo.mentor }}</p>
        <p><strong>时间：</strong>{{ courseInfo.year }}/{{ courseInfo.month }}/{{ courseInfo.day }}</p>
        <p><strong>证明开具日期：</strong>{{ courseInfo.up_year }}/{{ courseInfo.up_month }}/{{ courseInfo.up_day }}</p>
      </div>
    </el-card>
    <el-dialog
      title="提示"
      v-model="dialogVisible"
      width="30%"
      @close="dialogVisible = false"
    >
      <span>未找到开课信息</span>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      courseInfo: null,
      dialogVisible: false,
      systemTitle: '', // 存储系统标题
      logoSrc: '', // Logo图片的URL
    };
  },
  created() {
    this.fetchCourseInfo();
    this.fetchSystemTitleAndLogo(); // 在组件创建时获取系统标题和Logo
  },
  methods: {
    async fetchCourseInfo() {
      const id = this.$route.params.id; // 从路由参数获取ID
      try {
        const response = await axios.get(`/api/courses/${id}`);
        if (response.data.success) {
          this.courseInfo = response.data.course;
        } else {
          this.dialogVisible = true;
        }
      } catch (error) {
        console.error('Error fetching course info:', error);
        this.dialogVisible = true;
      }
    },
    fetchSystemTitleAndLogo() {
      // 获取系统标题
      axios.get('/api/system-title').then(response => {
        this.systemTitle = response.data.title;
        document.title = this.systemTitle; // 设置页面标题为系统标题
      }).catch(error => {
        console.error('Error fetching system title:', error);
      });

      // 获取Logo并更新Favicon
      axios.get('/api/logo', { responseType: 'blob' }).then(response => {
        const logoUrl = URL.createObjectURL(response.data);
        this.logoSrc = logoUrl;
        this.updateFavicon(logoUrl); // 更新favicon
      }).catch(error => {
        console.error('Error fetching logo:', error);
      });
    },
    updateFavicon(logoUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
  },
};
</script>

<style scoped>
.box-card {
  margin: 20px;
}

.header-content {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.logo {
  height: 40px;
  margin-right: 10px;
}

.title {
  font-size: 1.5em;
  font-weight: bold;
}
</style>
